// Lead statuses
export const LEAD_STATUS = {
  NEW: 'new',
  CONTACTED: 'contacted',
  QUALIFIED: 'qualified',
  MEETING_SCHEDULED: 'meeting_scheduled',
  PROPOSAL_SENT: 'proposal_sent',
  CONVERTED: 'converted',
  UNQUALIFIED: 'unqualified',
  LOST: 'lost',
  NURTURING: 'nurturing',
}

// Terminal statuses (end states)
export const TERMINAL_STATUSES = [LEAD_STATUS.LOST, LEAD_STATUS.UNQUALIFIED, LEAD_STATUS.CONVERTED]

export const leadStatusChoices = [
  { id: LEAD_STATUS.NEW, name: 'New' },
  { id: LEAD_STATUS.CONTACTED, name: 'Contacted' },
  { id: LEAD_STATUS.QUALIFIED, name: 'Qualified' },
  { id: LEAD_STATUS.MEETING_SCHEDULED, name: 'Meeting Scheduled' },
  { id: LEAD_STATUS.PROPOSAL_SENT, name: 'Proposal Sent' },
  { id: LEAD_STATUS.CONVERTED, name: 'Converted' },
  { id: LEAD_STATUS.UNQUALIFIED, name: 'Unqualified' },
  { id: LEAD_STATUS.LOST, name: 'Lost' },
  { id: LEAD_STATUS.NURTURING, name: 'Nurturing' },
]

// Lead sources
export const LEAD_SOURCE = {
  TYPEFORM: 'typeform',
  REFERRAL: 'referral',
  LINKEDIN: 'linkedin',
  USER: 'user',
  OTHER: 'other',
}

export const leadSourceChoices = [
  { id: LEAD_SOURCE.TYPEFORM, name: 'Typeform' },
  { id: LEAD_SOURCE.REFERRAL, name: 'Referral' },
  { id: LEAD_SOURCE.LINKEDIN, name: 'LinkedIn' },
  { id: LEAD_SOURCE.USER, name: 'Manual' },
  { id: LEAD_SOURCE.OTHER, name: 'Other' },
]

// Object map format (for Show/display components)
export const leadStatusMap = Object.fromEntries(leadStatusChoices.map(c => [c.id, c.name]))
export const leadSourceMap = Object.fromEntries(leadSourceChoices.map(c => [c.id, c.name]))

export const statusColors = {
  [LEAD_STATUS.NEW]: 'default',
  [LEAD_STATUS.CONTACTED]: 'primary',
  [LEAD_STATUS.QUALIFIED]: 'info',
  [LEAD_STATUS.MEETING_SCHEDULED]: 'success',
  [LEAD_STATUS.PROPOSAL_SENT]: 'warning',
  [LEAD_STATUS.CONVERTED]: 'success',
  [LEAD_STATUS.UNQUALIFIED]: 'error',
  [LEAD_STATUS.LOST]: 'error',
  [LEAD_STATUS.NURTURING]: 'secondary',
}
